import { api } from "./api"

export const accessedAtendimento = async (url: string, tela : string) => {
    return api.post(`/acesso-atendimento`, { url, tela })
}

export type updateAcessoAtendimento_requestDTO = {
    url?: string,
    acessadoEm: Date,
    formularioRespondido?: boolean,
    nome?: string,
    telefone?: string,
    id: number,
}

export const updateAtendimento = async (id: number, data: updateAcessoAtendimento_requestDTO) => {
    return api.patch(`/acesso-atendimento/${id}`, data)
}

const acessoAtendimentoAPi = {
    accessedAtendimento,
    updateAtendimento
}

export default acessoAtendimentoAPi;